$(document).ready(function(){

  // Open popup
 $(document).on('click', '.size-chart-trigger', function(){
    $('#sizeChartModal').fadeIn();
    $("body").addClass("overflow-hidden");
  });

  // Close popup (X button)
  $(document).on('click', '.size-chart-close', function(){
    $('#sizeChartModal').fadeOut();
     $("body").removeClass("overflow-hidden");
  });

  // Close on outside click
  $(window).on('click', function(e){
    if ($(e.target).is('#sizeChartModal')) {
      $('#sizeChartModal').fadeOut();
      $("body").removeClass("overflow-hidden");
    }
  });

  const addbtn = $('button[name="add"]');

if ($('variant-radios fieldset').length > 0) {
  addbtn.prop('disabled', true)
        .attr('aria-disabled', 'true')
        .text('Please select options');
}
$(document).on('change', 'variant-radios input[type="radio"]', function () {

  if ($(this).hasClass('disabled') || $(this).attr('aria-disabled') === 'true') {
    addbtn.prop('disabled', true)
      .attr('aria-disabled', 'true')
      .text('Sold out');
  } else {
    addbtn.prop('disabled', false)
      .attr('aria-disabled', 'false')
      .text('Add to cart');
  }

});

});

document.addEventListener('DOMContentLoaded', function() {
  const variantRadios = document.querySelector('variant-radios');
  
  if (variantRadios) {
    variantRadios.querySelectorAll('input[type="radio"]').forEach(el => {
      el.checked = false;
    });
  }
});